(function () {
  'use strict';

  angular
    .module('userActivityAuditReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('userActivityAuditReport', {
        url: '/user-activity-audit-report',
        views: {
          'userActivityAuditReportView': {
            templateUrl: 'user-activity-audit-report/views/user-activity-audit-report.tpl.html',
            controller: 'UserActivityAuditReportCtrl',
            controllerAs: 'userActivityAuditReport'
          }
        }
      });
  }
}());
